import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  InvoiceModelBean,
  InvoiceModelSearchCriteria,
  RestInvoiceModelListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class InvoiceModelListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
    this.state = {};
  }

  componentDidMount() {}

  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  editInvoiceModel = (e, val, rowdata) => {
    if (e.detail === 1) this.props.editInvoiceModel(val, rowdata);
  };
  deleteInvoiceModel = (e, val, rowData) => {
    if (e.detail === 1) this.props.deleteInvoiceModel(val, rowData);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms();
  };
  render() {
    let invoiceModel_list = this.props.invoiceModel_list;
    let invoiceModelData = this.props.invoiceModelData;

    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              <FormLabel id="searchBarLabel">InvoiceModel</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                type="text"
                name="code"
                enterKeyEventHandler={this.props.enterKeyEventHandler}
                onChange={this.props.onChange}
                value={invoiceModelData.code}
                style={{ "text-transform": "uppercase" }}
                ref={this.listFormCodeRef}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            {invoiceModel_list != null ? (
              <tbody>
                {invoiceModel_list.map((Info, index) => (
                  <tr key={index} data-item={Info}>
                    <td>
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.editInvoiceModel(e, Info.code)}
                      >
                        {Info.code}
                      </Button>
                    </td>

                    <td> {Info.description}</td>

                    <td>{Info.companyCode}</td>
                    <td>{Info.isActive}</td>
                    {/* <td className="text-right">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.deleteInvoiceModel(e, Info.code)
                        }
                      >
                        {<DeleteIcon />}
                      </Button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {invoiceModel_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class InvoiceModelEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();

    this.state = {
      showHide: this.props.showHide,
      invoiceModelData: this.props.invoiceModelData,
    };
  }

  componentDidMount() {
    this.setInputFocus();
  }

  componentDidUpdate() {
    //
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }

  onChange = (e) => {
    this.props.onChange(e);
  };

  saveInvoiceModel = (e) => {
    this.props.saveInvoiceModel(this.state.invoiceModelData);
  };

  closeInvoiceModelEntryForm() {
    this.props.closeInvoiceModelEntryForm();
  }

  render() {
    let invoiceModelData = this.props.invoiceModelData;
    let isDisableFields = this.props.isDisableFields;

    return (
      <div>
        <Row>
          <Col sm="2">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onChange}
              value={invoiceModelData.companyCode}
              disabled="true"
            />{" "}
          </Col>
          <Col sm="2">
            {" "}
            <FormLabel>Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="code"
              type="text"
              placeholder="Enter InvoiceModelCode"
              onChange={this.onChange}
              value={invoiceModelData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              ref={this.codeRef}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="2">
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={invoiceModelData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={invoiceModelData.isActive}
            />
          </Col>
        </Row>

        <br />
      </div>
    );
  }
}

class InvoiceModelList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      invoiceModel_list: [],
      response: {},
      pageTitle: "Invoice Model",
      invoiceModelData: new InvoiceModelBean(),
      pageList: new PageListBean(),
      criteria: new InvoiceModelSearchCriteria(),
      companyCode: "",

      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isInvoiceModelListFormOpen: true,
      isInvoiceModelEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,

      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadPage(1);
    this.cleardata();
    this.setState({ isShowCode: false });
  }

  moduleCaption = "Invoice Model";

  cleardata = () => {
    let invoiceModelData = new InvoiceModelBean();
    invoiceModelData.companyCode = this.companyCode;
    this.setState({ invoiceModelData: invoiceModelData });
  };
  opentypeforms = () => {
    let invoiceModelCode = this.state.invoiceModelData;
    this.editInvoiceModel(invoiceModelCode.code);
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  saveInvoiceModelResponse = (response) => {
    if (response.data.success) {
      this.handleresponse(response.data);
      this.loadPage(1);
      this.cleardata();
      this.clearError();
      this.closeInvoiceModelEntryForm();
      this.setState({ isShowCode: false });
    } else {
      this.handleresponse(response.data);
    }
  };

  saveInvoiceModel = (invoiceModelData) => {
    if (invoiceModelData.isFetched == true) {
      if (SecurityAccessManager.InvoiceModelMaintenanceEdit_IsAccessible()) {
        MasterService.updateInvoiceModel(
          invoiceModelData,
          this.saveInvoiceModelResponse,
          this.errorCallBack,
        );
      } else {
        let errMsg = "Edit Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.InvoiceModelMaintenanceCreate_IsAccessible()) {
        MasterService.createInvoiceModel(
          invoiceModelData,
          this.saveInvoiceModelResponse,
          this.errorCallBack,
        );
      } else {
        let errMsg = "Create Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };

  editInvoiceModelResponse = (response) => {
    if (response.data != null) {
      if (response.data.invoiceModelBean != null) {
        let invoiceModelData = response.data.invoiceModelBean;
        this.setState({
          invoiceModelData: invoiceModelData,
        });
        this.disable();
      }
    }
    this.openInvoiceModelEntryForm();
  };

  editInvoiceModel = (invoiceModelCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = invoiceModelCode;
    if (SecurityAccessManager.InvoiceModelMaintenanceView_IsAccessible()) {
      MasterService.readInvoiceModel(
        readrestInput,
        this.editInvoiceModelResponse,
        this.errorCallBack,
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  onChange = (e) => {
    let temp_invoiceModeldata = this.state.invoiceModelData;
    temp_invoiceModeldata[e.target.name] = e.target.value;
    this.setState({
      invoiceModelData: temp_invoiceModeldata,
    });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    let invoiceModelData = this.state.invoiceModelData;
    invoiceModelData.companyCode = this.companyCode;
    invoiceModelData.code = this.state.invoiceModelData.code.toUpperCase();
    this.clearError();
    this.saveInvoiceModel(invoiceModelData);
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeInvoiceModelEntryForm();
    this.componentDidMount();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };

  openInvoiceModelEntryForm = () => {
    this.setState({
      isInvoiceModelListFormOpen: false,
      isInvoiceModelEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closeInvoiceModelEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isInvoiceModelListFormOpen: true,
      isInvoiceModelEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,

      isShowClearErrorButton: false,
      pageTitle: pageTitle,

      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
    this.loadPage(1);
  };

  deleteInvoiceModel = (code, rowData) => {
    //
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };
  loadInvoiceModelResponse = (response) => {
    if (response.data != null && response.data.invoiceModelPageList != null) {
      let invoiceModelList = new Array();
      if (!isEmptyArray(response.data.invoiceModelPageList.invoiceModel)) {
        invoiceModelList = response.data.invoiceModelPageList.invoiceModel;
        invoiceModelList.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.currentPage = response.data.invoiceModelPageList.currentPage;
      pageList.pageSize = response.data.invoiceModelPageList.pageSize;
      pageList.totalCount = response.data.invoiceModelPageList.totalCount;
      this.setState({
        invoiceModel_list: invoiceModelList,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new InvoiceModelSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadInvoiceModelPage(pageInput, criteria);
  };
  loadInvoiceModelPage = (pageList, searchCriteria) => {
    let criteria = new InvoiceModelSearchCriteria();
    criteria = searchCriteria;

    let requestInput = new RestInvoiceModelListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (SecurityAccessManager.InvoiceModelMaintenanceView_IsAccessible()) {
      MasterService.getInvoiceModelPageList(
        requestInput,
        this.loadInvoiceModelResponse,
        this.errorCallBack,
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };

  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.invoiceModel_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ invoiceModel_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isInvoiceModelListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isInvoiceModelListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
            isShowTitle={true}
          />
        )}
        {this.state.isInvoiceModelListFormOpen && (
          <InvoiceModelListForm
            invoiceModel_list={this.state.invoiceModel_list}
            pageList={this.state.pageList}
            criteria={this.state.criteria}
            opentypeforms={this.opentypeforms}
            invoiceModelData={this.state.invoiceModelData}
            editInvoiceModel={this.editInvoiceModel}
            deleteInvoiceModel={this.deleteInvoiceModel}
            enterKeyEventHandler={this.enterKeyEventHandler}
            onChange={this.onChange}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {!this.state.isInvoiceModelListFormOpen && (
          <InvoiceModelEntryForm
            invoiceModelData={this.state.invoiceModelData}
            closeInvoiceModelEntryForm={this.closeInvoiceModelEntryForm}
            saveInvoiceModel={this.saveInvoiceModel}
            editInvoiceModel={this.editInvoiceModel}
            onChange={this.onChange}
            isDisableFields={this.state.isDisableFields}
          />
        )}
      </div>
    );
  }
}

function InvoiceModelAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <InvoiceModelList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default InvoiceModelAttributeModule;
